import axios from 'axios'

const REACTION = process.env.VUE_APP_REACTION;

class ReactionCalls {

  react(chapterId, userId, reaction) {
    return axios.put(REACTION + 'chapter/', { chapterId, userId, reaction })
    .then(response => response.data.reaction || null);
  }

  get(chapterId) {
    return axios.get(REACTION + 'chapter/' + chapterId)
    .then(response => response.data.reactions);
  }

}

const reactionCalls = new ReactionCalls();
export default reactionCalls;
